import { useEffect, useState } from 'react';
import { Select } from 'antd';

export const SingleSelect = ({ width, value, placeholder, options, onChange }) => {

  let style = {};
  if (width) {
    style = { width };
  }

  return <Select
            style={style}
            value={value}
            placeholder={placeholder}
            options={options}
            onChange={onChange} />;
};